<template>
    <span>
        <span class="upper" v-if="this.status === 'CONFERMATO'" style="color: #55cc5d;">
            {{$t("confermato")}}
        </span>
        <span class="upper" v-else-if="this.status === 'RIFIUTATO'" style="color: #f53838;">
            {{$t("rifiutato")}}
        </span>
        <span class="upper" v-else-if="this.status === 'ANNULLATO'" style="color: #a6a6a6;">
            {{$t("rifiutato")}}
        </span>
        <span class="upper" v-else style="color: #ffb20c;">
            {{$t("attesa")}}
        </span>
    </span>
</template>

<script>
    export default {
        name: "IncOrderStatus",
        props: ['status']
    }
</script>
